export default __webpack_public_path__ + "static/media/tokyo.27103b2e.jpg";